import { PieChart, Pie, Legend, Tooltip, Cell, ResponsiveContainer, Label } from 'recharts';
import React from 'react';
const AnalysisChart = ({ engagement }: any) => {
  const chartData = [
    { name: 'Login', value: engagement?.loggedInUsers, color: '#AFAFAF' },
    { name: 'Log out', value: engagement?.loggedOutUsers, color: '#FFFFFF' },
    { name: 'FAQ', value: engagement?.faqCount, color: '#006BEA' }
  ];
  const view = chartData.some((ele: any) => ele.value > 0);
  return (
    <ResponsiveContainer width="100%" height="100%">
      {view ? (
        <PieChart width={300} height={300}>
          <Pie
            dataKey="value"
            data={chartData}
            cx={'60%'}
            cy={'50%'}
            innerRadius={70}
            outerRadius={105}
            cornerRadius={8}
            stroke="none"
            paddingAngle={3}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
            <Label value="100%" position="center" fontSize={14} fontWeight="bold" fill="#ffffff" />
          </Pie>
          <Tooltip />
          <Legend
            align="right"
            verticalAlign="top"
            iconType="circle"
            iconSize={14}
            wrapperStyle={{ color: '#ffffff', borderRadius: 10 }}
            layout="vertical"
            formatter={(value) => (
              <span className="text-xs md:text-sm font-bold text-white ml-2">{value}</span>
            )}
          />
        </PieChart>
      ) : (
        <div
          className="flex justify-center items-center"
          style={{ width: '100%', height: '300px' }}
        >
          <div className="select-none">No records found</div>
        </div>
      )}
    </ResponsiveContainer>
  );
};

export default AnalysisChart;
